<template>
  <router-view :account-id="$route.params.carrierId" />
</template>

<script>
export default {
  data () {
    return {
      sidebar: [
        {
          icon: ['fal', 'file-invoice-dollar'],
          route: { name: 'manage-accounts-account-billings-invoicesurcharges', params: { accountId: this.$route.params.accountId } },
          name: 'Invoice Surcharges'
        }
      ],
      breadcrumb: {
        name: 'Billing',
        route: { name: 'manage-accounts-account-billings', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
